module.exports = __webpack_public_path__ + "static/media/Nike.ff478649.svg";